<template>
  <div class="text-center">
    <v-dialog :value="dialog" width="640">
      <v-card>
        <v-card-title class="headline grey lighten-2">
          {{ action }} {{ title }}
        </v-card-title>

        <!-- If creating or updating show editing tools -->
        <v-card-text v-if="!isRemoving">
          <v-form ref="frmRegister" v-if="game">
            <v-text-field required v-model="game.name" label="Game name"></v-text-field>
            <v-row>
              <v-col cols="12">
                <v-autocomplete :items="clients" item-text="name" item-value="id" label="Client" v-model="game.client_id"></v-autocomplete>
              </v-col>
            </v-row>
            <p v-if="isUpdating">Last updated: {{ game.updated_at}}</p>
          </v-form>
        </v-card-text>

        <!-- Else if Removing display different text -->
        <v-card-text v-else>
          <v-row>
            <v-col>
              <h3>Really remove {{ game.name }}?</h3>
              <br>
              <p>Date created: {{ game.created_at}}</p>
            </v-col>
          </v-row>
        </v-card-text>

        <v-divider></v-divider>

        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn v-if="isUpdating" color="info" @click="updateClient">
            {{ action }} {{ title }}
          </v-btn>
          <v-btn v-else-if="isRemoving" color="error" @click="removeClient">
            {{ action }} {{ title }}
          </v-btn>
          <v-btn v-else color="primary" @click="createClient">
            {{ action }} {{ title }}
          </v-btn>
          <v-btn :color="( isRemoving? 'success' : 'error' )" @click="$emit('cancel')">Cancel</v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
  export default {
    data() {
      return {
        title: "Jumble Word",
      }
    },
    props: ["dialog", "game", "isUpdating", "isRemoving"],
    computed: {
      action() {
        if (this.isUpdating) {
          return 'Update'
        } else if (this.isRemoving) {
          return 'Remove'
        } else {
          return 'Create'
        }
      },
      ...mapState('files', ['files']),
      ...mapState('clients', ['clients']),
      allFiles() {
        return this.files
      }
    },
    methods: {
      createClient() {
        if (this.$refs.frmRegister.validate()) {
          this.$store.dispatch('jumblewords/add', this.game)
          this.$emit('cancel')
        }
      },
      updateClient() {
        if (this.$refs.frmRegister.validate()) {
          this.$store.dispatch('jumblewords/update', this.game)
          this.$emit('cancel')
        }
      },
      removeClient() {
        this.$store.dispatch('jumblewords/remove', this.game)
        this.$emit('cancel')
      }
    }
  }
</script>